import { memo } from "react";


export const Nomatch = memo(() => {
    return (

		<section className="notfound">
        	<p>このページはありません。</p>
    	</section>
	)

})